// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2xtk2","image":"Header_image__bj7la","name":"Header_name__UCjVD","info":"Header_info__1JwmJ","infoRow":"Header_infoRow__1Hzy8"};